if (!window.w121QuickImagePreviewReady) {
  window.w121QuickImagePreviewReady = true;

  (() => {
    let dialog;
    let session;
    let loadRevision = 0;
    let escapePressed = false;

    function restoreList() {
      if (!session) return;
      const previous = session;
      session = null;
      loadRevision++;
      if (previous.addedScrollLock && !document.querySelector('modal-dialog[open], quick-add-modal[open], .product-quick-order-modal[open], cart-drawer.active')) {
        document.body.classList.remove('overflow-hidden');
      }
      let target = previous.opener;
      if (!target.isConnected) {
        const list = document.getElementById(previous.listId);
        target = previous.variantId
          ? list?.querySelector(`[data-variant-id="${previous.variantId}"] [data-quick-image-preview]`)
          : previous.parent?.querySelector('[data-quick-image-preview]');
        target ||= list?.querySelector('[data-quick-image-preview], input, button');
      }
      if (previous.parent?.isConnected && previous.parent.hasAttribute('open') && previous.parent.matches('modal-dialog, quick-add-modal') && typeof trapFocus === 'function') {
        trapFocus(previous.parent, target || previous.parent.querySelector('[role="dialog"]'));
      } else {
        target?.focus({ preventScroll: true });
      }
    }

    function closePreview() {
      if (!dialog?.open) return;
      dialog.close();
      restoreList();
    }

    function createPreview() {
      dialog = document.createElement('dialog');
      dialog.className = 'w121-quick-image-preview';
      dialog.innerHTML = '<div class="w121-quick-image-preview__frame"><div class="w121-quick-image-preview__header"><p class="w121-quick-image-preview__caption"></p><button type="button" class="w121-quick-image-preview__close" autofocus><span aria-hidden="true">×</span></button></div><div class="w121-quick-image-preview__media"><img alt="" decoding="async"></div><p class="w121-quick-image-preview__status" role="status" hidden></p></div>';
      dialog.querySelector('button').addEventListener('click', closePreview);
      dialog.addEventListener('click', (event) => {
        event.stopPropagation();
        if (event.target === dialog) closePreview();
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePreview();
      });
      dialog.addEventListener('close', () => {
        if (!dialog.open) restoreList();
      });
      document.body.appendChild(dialog);
    }

    document.addEventListener('click', (event) => {
      const opener = event.target.closest?.('[data-quick-image-preview]');
      if (!opener) return;
      event.preventDefault();
      event.stopPropagation();
      if (!dialog) createPreview();
      if (dialog.open) return;

      const thumbnail = opener.querySelector('img');
      if (!thumbnail) return;
      session = {
        opener,
        listId: opener.closest('quick-order-list')?.id || '',
        variantId: opener.closest('[data-variant-id]')?.dataset.variantId,
        parent: opener.closest('modal-dialog, quick-add-modal, .product-quick-order-modal'),
        addedScrollLock: !document.body.classList.contains('overflow-hidden'),
      };
      const image = dialog.querySelector('img');
      const status = dialog.querySelector('[role="status"]');
      const close = dialog.querySelector('button');
      const title = opener.dataset.previewAlt || thumbnail.alt;
      dialog.setAttribute('aria-label', opener.getAttribute('aria-label'));
      dialog.querySelector('.w121-quick-image-preview__caption').textContent = title;
      close.setAttribute('aria-label', opener.dataset.previewClose);
      image.alt = title;
      image.src = thumbnail.currentSrc || thumbnail.src;
      status.hidden = true;
      status.textContent = '';
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      document.body.classList.add('overflow-hidden');
      opener.focus({ preventScroll: true });
      dialog.showModal();
      close.focus({ preventScroll: true });

      const revision = ++loadRevision;
      const fullImage = new Image();
      fullImage.onload = () => {
        if (dialog.open && revision === loadRevision) image.src = fullImage.src;
      };
      fullImage.onerror = () => {
        if (!dialog.open || revision !== loadRevision) return;
        status.textContent = opener.dataset.previewError;
        status.hidden = false;
      };
      fullImage.src = opener.dataset.quickImagePreview;
    }, true);

    document.addEventListener('keydown', (event) => {
      if (!dialog?.open || event.key !== 'Escape') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      escapePressed = true;
    }, true);
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || (!dialog?.open && !escapePressed)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      escapePressed = false;
      closePreview();
    }, true);
  })();
}

if (!customElements.get('quick-order-list')) {
  customElements.define(
    'quick-order-list',
    class QuickOrderList extends BulkAdd {
      cartUpdateUnsubscriber = undefined;
      hasPendingQuantityUpdate = false;
      editRevision = 0;
      refreshRevision = 0;
      constructor() {
        super();
        this.isListInsideModal = this.closest('bulk-modal');

        this.stickyHeaderElement = document.querySelector('sticky-header');
        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute('data-sticky-type')}`,
          };
        }

        this.totalBar = this.getTotalBar();
        if (this.totalBar) {
          this.totalBarPosition = window.innerHeight - this.totalBar.offsetHeight;

          this.handleResize = this.handleResize.bind(this);
          window.addEventListener('resize', this.handleResize);
        }

        this.querySelector('form').addEventListener('submit', (event) => event.preventDefault());
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));

        this.initEventListeners();
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        window.removeEventListener('resize', this.handleResize);
      }

      get hasQueuedChanges() {
        return this.requestStarted || this.queue.length > 0 || this.hasPendingQuantityUpdate;
      }

      onCartUpdate(event) {
        if (event.source === this.id || this.hasQueuedChanges) return;
        const cartData = event.cartData;
        const inputs = this.querySelectorAll('input[data-index]');
        if (Array.isArray(cartData?.items) && typeof cartData.item_count === 'number') {
          const quantities = new Map();
          cartData.items.forEach((item) => {
            const id = String(item.variant_id || item.id);
            quantities.set(id, (quantities.get(id) || 0) + item.quantity);
          });
          if (![...inputs].some((input) => Number(input.dataset.cartQuantity) !== (quantities.get(input.dataset.index) || 0))) return;
        } else if (event.productVariantId && ![...inputs].some((input) => input.dataset.index === String(event.productVariantId))) {
          return;
        }
        const sectionHtml = cartData?.sections?.[this.dataset.section];
        if (typeof sectionHtml === 'string' && new DOMParser().parseFromString(sectionHtml, 'text/html').getElementById(this.id)) {
          this.renderSections(cartData, true);
        } else {
          this.refresh();
        }
      }

      startQueue(id, quantity) {
        this.editRevision++;
        this.hasPendingQuantityUpdate = true;
        super.startQueue(id, quantity);
        this.toggleLoading(true);
        this.paintPendingRows();
      }

      paintPendingRows() {
        const ids = new Set([...(this.activeVariantIds || []), ...this.queue.map((item) => String(item.id))]);
        this.querySelectorAll('.variant-item').forEach((row) => {
          const pending = ids.has(row.dataset.variantId);
          row.setAttribute('aria-busy', String(pending));
          row.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.toggle('hidden', !pending));
        });
      }

      handleResize() {
        this.totalBarPosition = window.innerHeight - this.totalBar.offsetHeight;
        if (this.stickyHeader) this.stickyHeader.height = this.stickyHeaderElement ? this.stickyHeaderElement.offsetHeight : 0;
      }

      initEventListeners() {
        this.querySelectorAll('.pagination__item').forEach((link) => {
          link.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();

            const url = new URL(event.currentTarget.href);

            this.toggleTableLoading(true);
            await this.refresh(url.searchParams.get('page') || '1');
            this.scrollTop();
            this.toggleTableLoading(false);
          });
        });

        this.querySelector('.quick-order-list__contents').addEventListener(
          'keyup',
          this.handleScrollIntoView.bind(this)
        );

        this.quickOrderListTable.addEventListener('keydown', this.handleSwitchVariantOnEnter.bind(this));

        this.initVariantEventListeners();
      }

      initVariantEventListeners() {
        this.allInputsArray = Array.from(this.querySelectorAll('input[data-index]'));

        this.querySelectorAll('quantity-input').forEach((qty) => {
          qty.addEventListener('change', (event) => {
            this.onChange(event);
          });
        });

        this.querySelectorAll('.quick-order-list-remove-button').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const input = this.querySelector(`input[data-index="${button.dataset.index}"]`);
            if (input) {
              input.value = '0';
              input.closest('quantity-input')?.validateQtyRules();
            }
            this.startQueue(button.dataset.index, 0);
          });
        });
      }

      get currentPage() {
        return this.querySelector('.pagination-wrapper')?.dataset?.page ?? '1';
      }

      get cartVariantsForProduct() {
        return JSON.parse(this.querySelector('[data-cart-contents]')?.innerHTML || '[]');
      }

      onChange(event) {
        const inputValue = parseInt(event.target.value);
        event.target.setCustomValidity('');
        if (!Number.isSafeInteger(inputValue)) return;
        if (inputValue == 0) {
          event.target.setAttribute('value', inputValue);
          this.startQueue(event.target.dataset.index, inputValue);
        } else {
          this.validateQuantity(event);
        }
      }

      cleanErrorMessageOnType(event) {
        const handleKeydown = () => {
          event.target.setCustomValidity(' ');
          event.target.reportValidity();
          event.target.removeEventListener('keydown', handleKeydown);
        };

        event.target.addEventListener('keydown', handleKeydown);
      }

      validateInput(target) {
        const targetValue = parseInt(target.value);
        const targetMin = parseInt(target.dataset.min);
        const targetStep = parseInt(target.step);

        if (target.max) {
          return (
            targetValue == 0 ||
            (targetValue >= targetMin && targetValue <= parseInt(target.max) && targetValue % targetStep == 0)
          );
        } else {
          return targetValue == 0 || (targetValue >= targetMin && targetValue % targetStep == 0);
        }
      }

      get quickOrderListTable() {
        return this.querySelector('.quick-order-list__table');
      }

      getSectionsToRender() {
        return [
          {
            id: this.id,
            section: this.dataset.section,
            selector: `#${this.id}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '#shopify-section-cart-icon-bubble',
          },
          {
            id: `quick-order-list-live-region-text-${this.dataset.productId}`,
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }

      toggleTableLoading(enable) {
        this.quickOrderListTable.classList.toggle('quick-order-list__container--disabled', enable);
        this.toggleLoading(enable);
      }

      async refresh(pageNumber = null) {
        const refreshRevision = ++this.refreshRevision;
        const editRevision = this.editRevision;
        const url = this.dataset.url || window.location.pathname;

        return fetch(`${url}?section_id=${this.dataset.section}&page=${pageNumber || this.currentPage}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const responseQuickOrderList = html.querySelector(`#${this.id}`);

            if (!responseQuickOrderList || refreshRevision !== this.refreshRevision || editRevision !== this.editRevision || this.hasQueuedChanges) {
              return;
            }

            this.innerHTML = responseQuickOrderList.innerHTML;
            this.initEventListeners();
          })
          .catch((e) => {
            console.error(e);
          });
      }

      renderSections(parsedState, listOnly = false) {
        const { items, sections } = parsedState;
        if (!sections) return;

        this.getSectionsToRender().forEach(({ id, selector, section }) => {
          if (listOnly && section !== this.dataset.section) return;
          if (typeof sections[section] !== 'string') return;
          const sectionElement = document.getElementById(id);
          if (!sectionElement) return;

          const newSection = new DOMParser().parseFromString(sections[section], 'text/html').querySelector(selector);
          if (!newSection) return;

          if (section === this.dataset.section) {
            if (this.queue.length > 0 || this.hasPendingQuantityUpdate) return;

            const focusedElement = document.activeElement;
            let focusTarget = focusedElement?.dataset?.target;
            if (focusTarget?.includes('remove')) {
              focusTarget = focusedElement.closest('quantity-popover')?.querySelector('[data-target*="increment-"]')
                ?.dataset.target;
            }

            const total = this.getTotalBar();
            if (total) {
              total.innerHTML = newSection.querySelector('.quick-order-list__total').innerHTML;
            }

            const table = this.quickOrderListTable;
            const newTable = newSection.querySelector('.quick-order-list__table');

            // only update variants if they are from the active page
            const shouldUpdateVariants =
              this.currentPage === (newSection.querySelector('.pagination-wrapper')?.dataset.page ?? '1');
            if (newTable && shouldUpdateVariants) {
              table.innerHTML = newTable.innerHTML;

              const newFocusTarget = this.querySelector(`[data-target='${focusTarget}']`);
              if (newFocusTarget) {
                newFocusTarget?.focus({ preventScroll: true });
              }

              this.initVariantEventListeners();
            }
          } else if (section === 'cart-drawer') {
            sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', items.length === 0);
            sectionElement.querySelector(selector).innerHTML = newSection.innerHTML;
          } else {
            sectionElement.innerHTML = newSection.innerHTML;
          }
        });
      }

      getTotalBar() {
        return this.querySelector('.quick-order-list__total');
      }

      scrollTop() {
        const { top } = this.getBoundingClientRect();

        if (this.isListInsideModal) {
          this.scrollIntoView();
        } else {
          window.scrollTo({ top: top + window.scrollY - (this.stickyHeader?.height || 0), behavior: 'instant' });
        }
      }

      scrollQuickOrderListTable(target) {
        const inputTopBorder = target.getBoundingClientRect().top;
        const inputBottomBorder = target.getBoundingClientRect().bottom;

        if (this.isListInsideModal) {
          const totalBarCrossesInput = inputBottomBorder > this.totalBar.getBoundingClientRect().top;
          const tableHeadCrossesInput =
            inputTopBorder < this.querySelector('.quick-order-list__table thead').getBoundingClientRect().bottom;

          if (totalBarCrossesInput || tableHeadCrossesInput) {
            this.scrollToCenter(target);
          }
        } else {
          const stickyHeaderBottomBorder = this.stickyHeaderElement?.getBoundingClientRect().bottom;
          const totalBarCrossesInput = inputBottomBorder > this.totalBarPosition;
          const inputOutsideOfViewPort =
            inputBottomBorder < this.querySelector('.variant-item__quantity-wrapper').offsetHeight;
          const stickyHeaderCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type !== 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder;
          const stickyHeaderScrollupCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type === 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder &&
            stickyHeaderBottomBorder > 0;

          if (
            totalBarCrossesInput ||
            inputOutsideOfViewPort ||
            stickyHeaderCrossesInput ||
            stickyHeaderScrollupCrossesInput
          ) {
            this.scrollToCenter(target);
          }
        }
      }

      scrollToCenter(target) {
        target.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      }

      handleScrollIntoView(event) {
        if (event.target.closest('[data-w121-request-product]')) return;
        if ((event.key === 'Tab' || event.key === 'Enter') && this.allInputsArray.length !== 1) {
          this.scrollQuickOrderListTable(event.target);
        }
      }

      handleSwitchVariantOnEnter(event) {
        if (event.key !== 'Enter' || event.target.tagName !== 'INPUT' || !event.target.hasAttribute('data-index')) return;

        event.preventDefault();
        event.target.blur();

        if (!this.validateInput(event.target) || this.allInputsArray.length <= 1) return;

        const currentIndex = this.allInputsArray.indexOf(event.target);
        const offset = event.shiftKey ? -1 : 1;
        const nextIndex = (currentIndex + offset + this.allInputsArray.length) % this.allInputsArray.length;

        this.allInputsArray[nextIndex]?.focus({ preventScroll: true });
        this.allInputsArray[nextIndex]?.select();
      }

      updateMultipleQty(items) {
        if (this.queue.length == 0) this.hasPendingQuantityUpdate = false;

        this.activeVariantIds = Object.keys(items);
        this.toggleLoading(true);
        this.paintPendingRows();
        const url = this.dataset.url || window.location.pathname;
        const sections = this.getSectionsToRender().map(({ section }) => section);
        if (window.WholesaleCart) sections.push('121-cart-state');

        const body = JSON.stringify({
          updates: items,
          sections: [...new Set(sections)],
          sections_url: `${url}?page=${this.currentPage}`,
        });

        this.updateMessage();
        this.setErrorMessage();

        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then(async (response) => {
            const parsedState = await response.json();
            if (!response.ok || parsedState.errors || parsedState.status >= 400) {
              throw new Error(typeof parsedState.description === 'string' ? parsedState.description : window.cartStrings.error);
            }
            this.renderSections(parsedState);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: this.id,
              cartData: parsedState,
            });
          })
          .catch((e) => {
            console.error(e);
            this.setErrorMessage(e.message || window.cartStrings.error);
            Object.keys(items).forEach((id) => {
              if (this.queue.some((item) => String(item.id) === id)) return;
              const input = this.querySelector(`input[data-index="${id}"]`);
              if (input) {
                input.value = input.dataset.cartQuantity;
                input.setAttribute('value', input.value);
                input.closest('quantity-input')?.validateQtyRules();
              }
            });
          })
          .finally(() => {
            this.activeVariantIds = [];
            this.queue.length === 0 && this.toggleLoading(false);
            this.paintPendingRows();
            this.setRequestStarted(false);
          });
      }

      setErrorMessage(message = null) {
        this.errorMessageTemplate =
          this.errorMessageTemplate ??
          document.getElementById(`QuickOrderListErrorTemplate-${this.dataset.productId}`).cloneNode(true);
        const errorElements = this.querySelectorAll('.quick-order-list-error');

        errorElements.forEach((errorElement) => {
          errorElement.innerHTML = '';
          if (!message) return;
          const updatedMessageElement = this.errorMessageTemplate.cloneNode(true);
          updatedMessageElement.content.querySelector('.quick-order-list-error-message').innerText = message;
          errorElement.appendChild(updatedMessageElement.content);
        });
      }

      updateMessage(quantity = null) {
        const messages = this.querySelectorAll('.quick-order-list__message-text');
        const icons = this.querySelectorAll('.quick-order-list__message-icon');

        if (quantity === null || isNaN(quantity)) {
          messages.forEach((message) => (message.innerHTML = ''));
          icons.forEach((icon) => icon.classList.add('hidden'));
          return;
        }

        const isQuantityNegative = quantity < 0;
        const absQuantity = Math.abs(quantity);

        const textTemplate = isQuantityNegative
          ? absQuantity === 1
            ? window.quickOrderListStrings.itemRemoved
            : window.quickOrderListStrings.itemsRemoved
          : quantity === 1
          ? window.quickOrderListStrings.itemAdded
          : window.quickOrderListStrings.itemsAdded;

        messages.forEach((msg) => (msg.innerHTML = textTemplate.replace('[quantity]', absQuantity)));

        if (!isQuantityNegative) {
          icons.forEach((i) => i.classList.remove('hidden'));
        }
      }

      updateError(updatedValue, id) {
        let message = '';
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        this.updateLiveRegions(id, message);
      }

      updateLiveRegions(id, message) {
        const variantItemErrorDesktop = document.getElementById(`Quick-order-list-item-error-desktop-${id}`);
        if (variantItemErrorDesktop) {
          variantItemErrorDesktop.querySelector('.variant-item__error-text').innerHTML = message;
          variantItemErrorDesktop.closest('tr').classList.remove('hidden');
        }
        if (variantItemErrorMobile)
          variantItemErrorMobile.querySelector('.variant-item__error-text').innerHTML = message;

        this.querySelector('#shopping-cart-variant-item-status').setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('quick-order-list-live-region-text');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
      }

      toggleLoading(loading, target = this) {
        target.querySelector('#shopping-cart-variant-item-status')?.setAttribute('aria-hidden', String(!loading));
        target
          .querySelectorAll('.variant-remove-total .loading__spinner')
          ?.forEach((spinner) => spinner.classList.toggle('hidden', !loading));
      }
    }
  );
}

if (!customElements.get('quick-order-list-remove-all-button')) {
  customElements.define(
    'quick-order-list-remove-all-button',
    class QuickOrderListRemoveAllButton extends HTMLElement {
      constructor() {
        super();
        this.quickOrderList = this.closest('quick-order-list');

        this.actions = {
          confirm: 'confirm',
          remove: 'remove',
          cancel: 'cancel',
        };

        this.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.dataset.action === this.actions.confirm) {
            this.toggleConfirmation(false, true);
          } else if (this.dataset.action === this.actions.remove) {
            const ids = new Set([
              ...this.quickOrderList.cartVariantsForProduct.map(String),
              ...this.quickOrderList.allInputsArray.filter((input) => Number(input.value) > 0).map((input) => input.dataset.index),
            ]);
            ids.forEach((id) => {
              const input = this.quickOrderList.querySelector(`input[data-index="${id}"]`);
              if (input) {
                input.value = '0';
                input.closest('quantity-input')?.validateQtyRules();
              }
              this.quickOrderList.startQueue(id, 0);
            });
            this.toggleConfirmation(true, false);
          } else if (this.dataset.action === this.actions.cancel) {
            this.toggleConfirmation(true, false);
          }
        });
      }

      toggleConfirmation(showConfirmation, showInfo) {
        this.quickOrderList
          .querySelector('.quick-order-list-total__confirmation')
          .classList.toggle('hidden', showConfirmation);
        this.quickOrderList.querySelector('.quick-order-list-total__info').classList.toggle('hidden', showInfo);
      }
    }
  );
}
